import React from 'react';
import '../css/banner.css';
import '../css/layout.css';
import '../css/utilities.css';
import defaultBannerPC from '../assets/images/banner.png'; // Main page default
import defaultBannerSP from '../assets/images/banner_sp.png';

function Banner({
  image,            // for a shared banner image
  imagePC,          // optional override for desktop
  imageSP,          // optional override for mobile
  altText = 'Banner image',
  className = '',
  children,
}) {
  // Use fallback logic:
  const bannerPC = imagePC || image || defaultBannerPC;
  const bannerSP = imageSP || image || defaultBannerSP;

  return (
    <section className={`banner ${className}`}>
      <div className="banner-content">
        {children}
        <img src={bannerPC} alt={altText} className="img-fluid u-d-onlyPC" />
        <img src={bannerSP} alt={altText} className="img-fluid u-d-onlySP" />
      </div>
    </section>
  );
}

export default Banner;